const EN = {
    title: 'Payment link position',
    table: {
        title: 'Payment link position',
        generation: {
            text: 'Payment links generation: ',
            blocked: 'BLOCKED',
            enabled: 'ENABLED',
        },
        columns: {
            totalMeasurementsSum: 'This Month',
            daily: 'Today',
        }
    }
};

export default EN;
